<div class="fz-leaderboard">
  <span class="bloc-title">Leaderboard</span>
  <ul>
    @for (item of leaderboard(); track item.rank; let i = $index) {
      <ol
        [attr.data-position]="item.rank"
        [style.animation-delay]="i * 0.2 + 's'"
        class="mat-body-medium"
        [class.item--empty]="!item.date"
      >
        <span class="name">{{ item.name }}</span>
        <span class="score">{{ item.date | date: 'dd/mm/yyyy' }}</span>
      </ol>
    }
  </ul>
</div>
